import { createRouter, createWebHistory } from 'vue-router';
import SlideView from '../views/SlideView.vue';
import SettingsView from '../views/SettingsView.vue';
import SubmitView from '../views/SubmitView.vue';

const routes = [
  { path: '/', name: 'Slide', component: SlideView },
  { path: '/settings', name: 'Settings', component: SettingsView },
  { path: '/submit', name: 'Submit', component: SubmitView }
];

export default createRouter({
  history: createWebHistory(),
  routes
});
